import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        outcomeIcon: {
            fontSize: 16,
            display: 'block',
        },
        approved: {
            color: palette.success.main,
        },
        denied: {
            color: palette.error.main,
        },
        error: {
            color: palette.error.main,
        },
        pending: {
            color: theme.palette.text.secondary,
        },
        cancelled: {
            color: theme.palette.text.secondary,
        },
    })
})

export const OutcomeBannerStyles: moduleStyleType = {
    container: {
        marginBottom: 3,
    },
}

export const OutcomeStyles: moduleStyleType = {
    iconContainer: {
        marginRight: 1,
    },
}
